import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import renderContentfulBody from './richTextRenderer/renderContentfulBody';
import Cutouts from '../../components/Cutouts';
import TextAlignment from '../../components/TextAlignment';
import Video from '../../components/Video';
import styles from './SideBySideSection.module.css';
import CloudinaryMedia from '../../components/CloudinaryMedia';

/**
 * @param {FF.ContentfulSideBySideSectionProps} props
 */
function SideBySide({
  bodyText,
  className,
  cutouts,
  leftSideImage,
  image,
  imageCaption,
  cloudinaryMedia,
  subtitle,
  textAlignment,
  title,
}) {
  const isVideo = image?.mimeType.startsWith('video/');
  const isImage = image?.mimeType.startsWith('image/');

  if (!image && !cloudinaryMedia) {
    throw new Error('need to provide either image or cloudinaryMedia');
  }

  return (
    <Cutouts cutouts={cutouts}>
      <div className={className}>
        {title && <h2 className={styles.title}>{title}</h2>}
        {subtitle && <p>{subtitle.subtitle}</p>}
        <div
          className={
            leftSideImage
              ? styles.leftSideImageWrapper
              : styles.rightSideImageWrapper
          }
        >
          <figure className={styles.figureWrapper}>
            {cloudinaryMedia && (
              <CloudinaryMedia
                {...cloudinaryMedia[0]}
                lazyload
                breakpoints={[480, 1000]}
              />
            )}
            {!cloudinaryMedia && image && (
              <>
                {
                  /**
                   * TODO: add sizing optimization so that smaller image is loaded on desktop,
                   *       where image max width is 474px
                   */
                  isImage && (
                    <GatsbyImage
                      alt={image.description}
                      image={image.gatsbyImageData}
                      loading="lazy"
                    />
                  )
                }
                {isVideo && (
                  <Video description={image.description} url={image.url} />
                )}
              </>
            )}
            {imageCaption && (
              <figcaption className={styles.caption}>
                {imageCaption.imageCaption}
              </figcaption>
            )}
          </figure>
          <TextAlignment
            alignment={textAlignment}
            className={styles.textWrapper}
          >
            <div className={styles.bodyText}>
              {renderContentfulBody(bodyText)}
            </div>
          </TextAlignment>
        </div>
      </div>
    </Cutouts>
  );
}

export default SideBySide;
